"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const pino_1 = __importDefault(require("pino"));
const strings_1 = require("../../../../../../../constants/strings");
const sessionQuery_1 = require("../../../../../../../queries/sessionQuery");
const phoneNumberUtils_1 = require("../../../../../../../utils/phoneNumberUtils");
const zustandStore_1 = require("../../../../../../../zustandStore");
const formWrapper_1 = __importDefault(require("../../../formWrapper"));
const formInput_1 = __importDefault(require("../../common/formInput"));
const temporaryPasswordForm_1 = require("../step_2/temporaryPasswordForm");
const logger = (0, pino_1.default)();
const VerifyPhoneSetupForm = () => {
    const { steps, setPageLoading, setCurrentStep, setNotification } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const askForSmsCod = (0, sessionQuery_1.useAskForSmsCodeQuery)();
    const phoneNumber = steps.data?.phoneSetup?.phoneDetails?.fullPhoneNumber;
    const maskedPhoneNumber = (0, phoneNumberUtils_1.maskPhoneNumber)(steps.data?.phoneSetup?.phoneDetails?.phoneCountryCode, steps.data?.phoneSetup?.phoneDetails?.phoneNumber);
    const handleSubmit = (e) => {
        e.preventDefault();
        setPageLoading(true);
        askForSmsCod.mutate(void 0, {
            onSuccess: () => {
                setCurrentStep(steps.currentStep + 1);
            },
            onError: error => {
                logger.error({ error });
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: 'Sorry, we are having technical difficulties. Please try again later.',
                    },
                ]);
            },
            onSettled: () => {
                setPageLoading(false);
            },
        });
    };
    return ((0, jsx_runtime_1.jsxs)(formWrapper_1.default, { formName: "Verify your phone number", onSubmit: handleSubmit, submitButton: {
            label: 'Send Code',
            isDisabled: !phoneNumber,
        }, isFormPending: askForSmsCod.isPending, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", sx: { marginBottom: '16px' }, children: "HSBC Business Virtual Cards requires two-step authentication when you use virtual cards in order to keep your account and payments secure." }), (0, jsx_runtime_1.jsx)(formInput_1.default, { label: "Phone number", type: "tel", name: "phoneNumber", value: maskedPhoneNumber || 'N/A', onChange: () => ({}), onBlur: () => ({}), readOnly: true, endAdornment: (0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "end", children: (0, jsx_runtime_1.jsx)(temporaryPasswordForm_1.CustomHSBCRequiredIcon, {}) }) })] }));
};
exports.default = VerifyPhoneSetupForm;
